import { useRef, useState } from "react";
import BreadCrumb from "components/common/BreadCrumb";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
} from "reactstrap";
import { getDocumentTitle } from "utils/helpers";
import { PayrollRunsTable } from "./PayrollRunsTable";
import GeneratePayrollRunModal from "./GeneratePayrollRunModal";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";

const PayrollRunList = () => {
  document.title = getDocumentTitle("Payroll");
  const { can } = useAccess();
  const tableRef = useRef<(() => void) | null>(null);
  const [generateOpen, setGenerateOpen] = useState(false);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Payroll" pageTitle="Finance" />
        {can(Permissions.PAYROLL.CREATE) && (
          <Alert
            color="light"
            className="border mb-3 d-flex align-items-center gap-2 py-2"
            fade={false}
          >
            <i className="ri-lightbulb-line text-warning fs-16 flex-shrink-0" />
            <span className="text-muted small">
              The <strong>Generate run</strong> wizard includes an eligibility
              preview — review it before confirming to catch employees missing a
              salary structure or join date.
            </span>
          </Alert>
        )}
        <Card>
          <CardHeader className="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <h5 className="card-title mb-0">Payroll runs</h5>
            {can(Permissions.PAYROLL.CREATE) && (
              <Button color="primary" onClick={() => setGenerateOpen(true)}>
                <i className="ri-add-line align-bottom me-1"></i>
                Generate run
              </Button>
            )}
          </CardHeader>
          <CardBody>
            <PayrollRunsTable refreshRef={tableRef} />
          </CardBody>
        </Card>
      </Container>
      <GeneratePayrollRunModal
        isOpen={generateOpen}
        onClose={() => setGenerateOpen(false)}
        onCreated={() => {
          tableRef.current?.();
        }}
      />
    </div>
  );
};

export default PayrollRunList;
